import Grid from "@mui/material/Grid";
import {Card, SvgIcon, Typography} from "@mui/material";
import moment from "moment";
import {formatDate} from "~/apps/core/utils";
import React from "react";
import {VesselCall} from "~/queries";
import {Box} from "@mui/system";
import {useTheme} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";


export type VesselCallLogsProps = {
    vesselCall: VesselCall
}


const Item = ({children, header}: {children: any, header?: boolean}) => {
    const theme = useTheme<PortTheme>();
    return (
        <Box
            bgcolor={header ? theme.palette.additionalPrimaryDisabled.main : null}
            paddingY="10px" paddingX="10px" width="100%">
            {children}
        </Box>
    )
}


export const VesselCallLogs = React.memo((props: VesselCallLogsProps) => {
    const {vesselCall} = props;

    if (vesselCall.operations.length == 0) {
        return (
            <ErrorBlock icon={
                <SvgIcon style={{fontSize: "36px"}}>
                    <path d="M8.69279 7.31764C8.1251 7.31764 7.6649 7.77784 7.6649 8.34553C7.6649 8.91322 8.1251 9.37342 8.69279 9.37342H14.8601C15.4278 9.37342 15.888 8.91322 15.888 8.34553C15.888 7.77784 15.4278 7.31764 14.8601 7.31764H8.69279Z"/>
                    <path d="M7.6649 12.4571C7.6649 11.8894 8.1251 11.4292 8.69279 11.4292H14.8601C15.4278 11.4292 15.888 11.8894 15.888 12.4571C15.888 13.0248 15.4278 13.485 14.8601 13.485H8.69279C8.1251 13.485 7.6649 13.0248 7.6649 12.4571Z"/>
                    <path d="M8.69279 15.5407C8.1251 15.5407 7.6649 16.0009 7.6649 16.5686C7.6649 17.1363 8.1251 17.5965 8.69279 17.5965H12.8043C13.372 17.5965 13.8322 17.1363 13.8322 16.5686C13.8322 16.0009 13.372 15.5407 12.8043 15.5407H8.69279Z"/>
                    <path d="M8.62512 2.1782C7.71391 2.17815 6.9288 2.1781 6.30008 2.26263C5.62628 2.35322 4.98041 2.55751 4.45653 3.08138C3.93265 3.60526 3.72837 4.25113 3.63778 4.92493C3.55325 5.55365 3.55329 6.33876 3.55334 7.24997V16.6363C3.55329 17.5475 3.55325 18.3326 3.63778 18.9613C3.72837 19.6351 3.93265 20.281 4.45653 20.8049C4.98041 21.3288 5.62628 21.5331 6.30008 21.6236C6.9288 21.7082 7.71393 21.7081 8.62515 21.7081H14.9278C15.839 21.7081 16.6241 21.7082 17.2528 21.6236C17.9266 21.5331 18.5725 21.3288 19.0964 20.8049C19.6203 20.281 19.8245 19.6351 19.9151 18.9613C19.9997 18.3326 19.9996 17.5475 19.9996 16.6363V7.24997C19.9996 6.33876 19.9997 5.55365 19.9151 4.92493C19.8245 4.25113 19.6203 3.60526 19.0964 3.08138C18.5725 2.55751 17.9266 2.35322 17.2528 2.26263C16.6241 2.1781 15.839 2.17815 14.9278 2.1782H8.62512ZM5.91018 4.53504C5.98843 4.45679 6.12817 4.36002 6.57401 4.30008C7.04941 4.23616 7.69463 4.23398 8.69279 4.23398H14.8601C15.8583 4.23398 16.5035 4.23616 16.9789 4.30008C17.4247 4.36002 17.5645 4.45679 17.6427 4.53504C17.721 4.61328 17.8177 4.75302 17.8777 5.19886C17.9416 5.67426 17.9438 6.31948 17.9438 7.31764V16.5686C17.9438 17.5668 17.9416 18.212 17.8777 18.6874C17.8177 19.1333 17.721 19.273 17.6427 19.3512C17.5645 19.4295 17.4247 19.5263 16.9789 19.5862C16.5035 19.6501 15.8583 19.6523 14.8601 19.6523H8.69279C7.69463 19.6523 7.04941 19.6501 6.57401 19.5862C6.12817 19.5263 5.98843 19.4295 5.91018 19.3512C5.83194 19.273 5.73516 19.1333 5.67522 18.6874C5.61131 18.212 5.60912 17.5668 5.60912 16.5686V7.31764C5.60912 6.31948 5.61131 5.67426 5.67522 5.19886C5.73516 4.75302 5.83194 4.61328 5.91018 4.53504Z"/>
                </SvgIcon>
            }>
                Судовой журнал будет заполняться при обработке судна
            </ErrorBlock>

        )
    }

    return (
        <Box paddingY={2}>
            <Card>
                <Grid container direction="column" wrap="nowrap">
                    {vesselCall.operations?.map((item, index) => (
                        <React.Fragment key={index}>
                            {(index == 0 || !moment(item.date).isSame(vesselCall.operations[index - 1]?.date, "day")) && (
                                <Grid item>
                                    <Item header={true}>
                                        <Typography color="white" variant="cardTitle2">
                                            {formatDate(moment(item.date))}
                                        </Typography>
                                    </Item>
                                </Grid>
                            )}
                            <Grid item>
                                <Item>
                                    <Grid container>
                                        <Grid item container direction="row" justifyContent="space-between">
                                            <Grid item>
                                                <Typography variant="inputText2" color="primary">
                                                    {item.operation}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="inputText2" color="primary">
                                                    {moment(item.date).format("HH:mm")}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="inputTitle2" color="textSecondary">
                                                {item.berth && <>Причал: {item.berth}&nbsp;&nbsp;&nbsp;</>}

                                                {item.terminal && <>Терминал: {item.terminal}</>}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Item>
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>
            </Card>
        </Box>
    )
});